"use client";
import { GlobalContext } from "@/context";
import Image from "next/image";
import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import { useContext, useEffect, useState } from "react";

const Navbar = () => {
  const router = useRouter();
  const { connected } = useContext(GlobalContext);
  const [mounted, setMounted] = useState(false);
  
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (mounted && !connected) {
      router.push("/");
    }
  }, [connected, mounted, router]);
  
  const path = usePathname();
  const visible = path && path.split("/")[1] !== "" ? true : false;
  const [position, setPosition] = useState(0);
  const [showFull, setShowFull] = useState(false);

  const list = [
    {
      img: "/navbar/dashboard.png",
      title: "Dashboard",
      link: "/dashboard",
    },
    {
      img: "/navbar/commandes.png",
      title: "Les commandes",
      link: "/commandes",
    },

    {
      img: "/navbar/rapport.png",
      title: "Des rapports",
      link: "/rapport",
    },
    {
      img: "/navbar/ajouter.png",
      title: "Importer des produits",
      link: "/importerproduits",
    },
    {
      img: "/navbar/produitList.png",
      title: "List de Produit",
      link: "/produit",
    },
    {
      img: "/navbar/utilisater.png",
      title: "Utilisateurs",
      link: "/utilisateurs",
    },
    {
      img: "/navbar/donnees.png",
      title: "Demande Produit",
      link: "/demandeclient",
    },
    {
      img: "/navbar/facture.png",
      title: "Données de facturation",
      link: "/facturation",
    },
    {
      img: "/navbar/avis.png",
      title: "Avis clients",
      link: "/avis",
    },
    {
      img: "/navbar/reglage.png",
      title: "Réglage",
      link: "/reglage",
    },
  ];

  // Prevent hydration mismatch by not rendering until mounted
  if (!mounted) {
    return null;
  }

  return (
    <div>
      {visible ? (
        <div
          className={`h-[100vh] bg-[#CC0001] flex rounded-tr-[59px] rounded-br-[62px] fixed z-10 ${
            showFull ? "w-[15%]" : "w-fit"
          }`}
        >
          <div className={`flex flex-col py-14 justify-between`}>
            {list.map((el, index) => {
              return (
                <div
                  className={`flex items-center gap-4 ${
                    showFull ? "pl-5" : "px-5"
                  }`}
                  key={index}
                >
                  <Image
                    src={el.img}
                    width={1000}
                    height={1000}
                    className="!w-[35px] !h-[35px] cursor-pointer"
                    alt={el.title}
                    onClick={() => {
                      setShowFull(true);
                      setPosition(index);
                    }}
                  />
                  <Link
                    href={el.link}
                    className={`${
                      index == 1 ? "whitespace-nowrap" : ""
                    }	 w-fit text-[16px] font-medium text-[#FFFFFF]  ${
                      showFull ? "block" : "hidden"
                    }`}
                    onClick={() => setPosition(index)}
                  >
                    {el.title}
                  </Link>
                </div>
              );
            })}
          </div>
          <h2
            className={`w-[20px] text-[30px] text-[#FFFFFF] cursor-pointer self-center ${
              showFull ? "mr-2" : "mx-0"
            }`}
            onClick={() => setShowFull(!showFull)}
          >
            {showFull ? "<" : ">"}
          </h2>
        </div>
      ) : null}
    </div>
  );
};

export default Navbar;
